<div class="container">
  <div class="page_container">
    <div *ngIf="!eventService.cfcLoadStats;else load">
      <div class="spacer sm"></div>
      <div class="col-md-12">
        <div class="big_block points cfc">
          <div class="content text-center">
            <p tooltip="Date"><i class="icon-calendar"></i>17 JAN - 1 FEB</p>

            <p tooltip="Unique participants"><i class="icon-user"></i> Unique: {{eventService?.cfcAllStats?.unique_users}}
            </p>
            <p tooltip="Total participants"><i class="icon-users"></i> Total Participations: {{eventService?.cfcAllStats?.total_participants}}
            </p>
          </div>
        </div>
      </div>
      <div class="spacer sm"></div>
      <div class="col-md-3" *ngFor="let day of eventService?.cfcLeaderBoardStats;let index=index">
        <div class="big_block points cfc">
          <div class="content text-center">
            <p tooltip="Date"><i class="icon-calendar"></i>{{day?.date?day?.date:'Date has not been specified yet'}}</p>
            <p tooltip="Unique participants"><i class="icon-user"></i> {{day?.unique_users}}
            </p>
            <p tooltip="Total participants"><i class="icon-users"></i> {{day?.total_participants}}
            </p>
          </div>
        </div>
      </div>
    </div>
    <ng-template #load>
      <app-loading-indicator></app-loading-indicator>
    </ng-template>
  </div>
</div>
